import React, { forwardRef } from 'react';
import Typography from '../Text/Typography';
import Icon from '../Icon/Icon';
import './Button.css';

export type ButtonVariant = 
    | 'primary'
    | 'secondary'
    | 'text';

interface ButtonProps {
    variant: ButtonVariant;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    type?: 'button' | 'submit' | 'reset';
    onClick?: () => void;
    disabled?: boolean;
    icon?: {
        name: string;
        size?: 'small' | 'large';
        className?: string;
    };
}       

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
    variant,
    children,
    className,
    style,
    type = 'button',
    onClick,
    disabled = false,
    icon,
}, ref) => {
    const buttonClass = `button button-${variant}`;
    const combinedClassName = `${buttonClass} ${className || ''}`.trim();

    return (
        <button
            type={type}
            ref={ref}
            className={combinedClassName}
            style={style}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
        >
            {icon && (
                <Icon name={icon.name} size={icon.size || 'small'} className={icon.className} />
            )}
            <Typography variant="body" style={{ margin: 0 }}>
                {children}
            </Typography>
        </button>
    );
});

Button.displayName = 'Button';

export default Button;